import { v4 as uuidv4 } from 'uuid';
import { getDeviceId } from 'Common/util/Net';
import { getAuthToken } from 'Common/util/Auth';

const APP_VERSION = '1.0.0';

function getUserAgent(): string {
  const platform = 'Web';
  const osName = getOSName();
  const browserInfo = getBrowserInfo();

  return `Dazzle/${APP_VERSION} (${platform}; OS/${osName}; Device/${browserInfo.name}; Browser/${browserInfo.name}; Version/${browserInfo.version})`;
}

function getOSName(): string {
  const userAgent = navigator.userAgent;

  if (userAgent.indexOf('Win') !== -1) return 'Windows';
  if (userAgent.indexOf('Mac') !== -1) return 'macOS';
  if (userAgent.indexOf('Linux') !== -1) return 'Linux';
  if (userAgent.indexOf('Android') !== -1) return 'Android';
  if (userAgent.indexOf('iOS') !== -1) return 'iOS';

  return 'Unknown';
}

function getBrowserInfo(): { name: string; version: string } {
  const userAgent = navigator.userAgent;

  let name = 'Unknown';
  let version = 'Unknown';

  if (userAgent.indexOf('Chrome') !== -1 && userAgent.indexOf('Edg') === -1) {
    name = 'Chrome';
    const match = userAgent.match(/Chrome\/(\S+)/);
    if (match) version = match[1];
  } else if (userAgent.indexOf('Safari') !== -1 && userAgent.indexOf('Chrome') === -1) {
    name = 'Safari';
    const match = userAgent.match(/Version\/(\S+)/);
    if (match) version = match[1];
  } else if (userAgent.indexOf('Firefox') !== -1) {
    name = 'Firefox';
    const match = userAgent.match(/Firefox\/(\S+)/);
    if (match) version = match[1];
  } else if (userAgent.indexOf('Edg') !== -1) {
    name = 'Edge';
    const match = userAgent.match(/Edg\/(\S+)/);
    if (match) version = match[1];
  }

  return { name, version };
}

export function getApiHeaders(): Record<string, string> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-User-Agent': getUserAgent(),
    'X-Device-ID': getDeviceId(),
    'X-Request-ID': uuidv4(),
  };

  const authToken = getAuthToken();
  if (authToken) {
    headers['Authorization'] = `Bearer ${authToken}`;
  }

  return headers;
}
